import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-list-manager',
    templateUrl: './list-manager.component.html',
    styleUrls: ['./list-manager.component.scss'],
    standalone: false
})
export class ListManagerComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
